import clock from '~/assets/icons/clock.svg';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { StyedTopContainer, StyledContainer } from './Waiting.styled';

const Waiting = () => {
	const opponentName = useObservable(rage.rockPaperScissors.getOpponentName());

	return (
		<StyledContainer>
			<StyedTopContainer>
				<img src={clock} />
				<Text style={{ fontSize: 18, fontWeight: 500, color: '#ffffff' }}>
					Ожидание {opponentName}
				</Text>
				<Text
					style={{
						fontSize: 16,
						color: '#ffffff',
						opacity: 0.25,
						fontStyle: 'italic',
						textAlign: 'center',
					}}
				>
					Предложение поиграть в “Камень, ножницы, бумага”
					<br />
					было отправлено игроку!
				</Text>
			</StyedTopContainer>
			<Button
				color={ButtonColors.Default}
				height={ButtonHeight.Height40}
				style={{ width: 220 }}
			>
				<Text onClick={() => rage.rockPaperScissors.cancelOffer()}>
					Отменить предложение
				</Text>
			</Button>
		</StyledContainer>
	);
};

export { Waiting };
